<input matInput [formControl]="correctedPotentialForm" (blur)="onInputBlur()">
